import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {EMPTY, Observable, of} from 'rxjs';
import {PlaceDTO, PlaceRank, PlaceStats} from '@domain/place/place.dto';
import {PlaceApi} from '@domain/place/place.api';
import {ActivityUtil} from '@domain/activity/activity.util';
import {StringUtil} from '@shared/util/string.util';
import {catchError} from 'rxjs/operators';


export class PlaceResolver {

  public static getRegions: ResolveFn<PlaceDTO[]> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<PlaceDTO[]> => {
    const api = inject(PlaceApi);
    return api.getRegions();
  };

  public static get: ResolveFn<PlaceDTO | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<PlaceDTO | null> => {
    const api = inject(PlaceApi);
    const placeId = this.resolvePlaceId(route);
    if (!placeId) {
      return of(null);
    }
    return api.getById(placeId).pipe(
      catchError(err => {
        if (err.status === 404) {
          // Redirect to not-found or another page
          return of(null);
        }
        // Return EMPTY to cancel current navigation
        return EMPTY;
      })
    );
  };

  public static getStats: ResolveFn<PlaceStats | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<PlaceStats | null> => {
    const api = inject(PlaceApi);
    const placeId = this.resolvePlaceId(route);
    if (!placeId) {
      return of(null);
    }
    return api.getStats(placeId);
  };

  public static getRegionByCode(regionCode: string) {
    return (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<PlaceDTO | null> => {
      const api = inject(PlaceApi);
      return api.getRegionByCode(regionCode).pipe(
        catchError(_ => of(null))
      );
    };
  }

  public static resolvePlaceId(route: ActivatedRouteSnapshot): string | null {
    let placeId = route.paramMap.get('placeId');
    if (!placeId) {
      placeId = StringUtil.resolveSlug(route.paramMap.get('slug'));
    }
    return placeId ?? null;
  }

}
